import dateTimeFormatter from '../../../components/valueFormatter/dateTimeFormatter';
import organizationUserValueGetter from '../../../components/valueGetter/organizationUserValueGetter';
import businessTypeValueGetter from '../../../components/valueGetter/businessTypeValueGetter';
import steelCategoryValueGetter from '../../../components/valueGetter/steelCategoryValueGetter';
import steelMakerValueGetter from '../../../components/valueGetter/steelMakerValueGetter';
import tradingCompanyValueGetter from '../../../components/valueGetter/tradingCompanyValueGetter';
import tradingCompanyFilterValueGetter from '../../../components/filterValueGetter/tradingCompanyFilterValueGetter';
import steelMakerFilterValueGetter from '../../../components/filterValueGetter/steelMakerFilterValueGetter';
import businessTypeFilterValueGetter from '../../../components/filterValueGetter/businessTypeFilterValueGetter';
import steelCategoryFilterValueGetter from '../../../components/filterValueGetter/steelCategoryFilterValueGetter';
import updatedByFilterValueGetter from '../../../components/filterValueGetter/updatedByFilterValueGetter';
import createdByFilterValueGetter from '../../../components/filterValueGetter/createdByFilterValueGetter';
import dateFilterComparator from '../../../utils/ag-grid/dateFilterComparator';
import useUserRoles from '../../useUserRoles';
import type { TFunction } from 'i18next';
import type { ColDef } from 'ag-grid-community';

const useColdefManageUser = (t: TFunction<'translation', undefined>) => {
  const { isMaintenanceadmin } = useUserRoles();

  const colDefs: ColDef[] = [
    {
      headerName: '',
      colId: 'actions',
      cellRenderer: 'actionsRenderer',
      editable: false,
      filter: false,
      pinned: 'left',
      suppressMenu: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      width: 90,
      hide: !isMaintenanceadmin,
    },
    {
      colId: 'tradingCompany',
      headerName: t('tradingCompany.tradingCompany'),
      headerTooltip: t('tradingCompany.tradingCompany'),
      valueGetter: tradingCompanyValueGetter,
      cellRenderer: 'tradingCompanyCellRenderer',
      filterValueGetter: tradingCompanyFilterValueGetter,
      width: 100,
      hide: !isMaintenanceadmin,
    },
    {
      colId: 'organizations',
      headerName: t('organization.organization'),
      headerTooltip: t('organization.organization'),
      valueGetter: organizationUserValueGetter,
    },
    {
      colId: 'steelMaker',
      headerName: t('steelMaker'),
      headerTooltip: t('steelMaker'),
      valueGetter: steelMakerValueGetter,
      cellRenderer: 'steelMakerCellRenderer',
      filterValueGetter: steelMakerFilterValueGetter,
      width: 180,
    },
    {
      colId: 'businessType',
      headerName: t('businessType'),
      headerTooltip: t('businessType'),
      valueGetter: businessTypeValueGetter,
      cellRenderer: 'businessTypeCellRenderer',
      filterValueGetter: businessTypeFilterValueGetter,
      width: 75,
    },
    {
      colId: 'steelCategory',
      headerName: t('steelCategory'),
      headerTooltip: t('steelCategory'),
      valueGetter: steelCategoryValueGetter,
      cellRenderer: 'steelCategoryCellRenderer',
      filterValueGetter: steelCategoryFilterValueGetter,
      width: 100,
    },
    {
      field: 'username',
      headerName: t('user.name'),
      headerTooltip: t('user.name'),
      width: 180,
    },
    {
      field: 'email',
      headerName: t('user.email'),
      headerTooltip: t('user.email'),
      width: 180,
    },
    {
      field: 'roles',
      headerName: t('user.role'),
      headerTooltip: t('user.role'),
      maxWidth: 125,
    },
    {
      field: 'updatedAt',
      headerName: t('grid.updatedAt'),
      headerTooltip: t('grid.updatedAt'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateTimeFormatter,
      minWidth: 100,
      maxWidth: 150,
    },
    {
      field: 'updatedBy',
      headerName: t('grid.updatedBy'),
      headerTooltip: t('grid.updatedBy'),
      cellRenderer: 'userNameFromEmailCellRenderer',
      filterValueGetter: updatedByFilterValueGetter,
      minWidth: 100,
      maxWidth: 200,
    },
    {
      field: 'createdAt',
      headerName: t('grid.createdAt'),
      headerTooltip: t('grid.createdAt'),
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: dateFilterComparator,
      },
      valueFormatter: dateTimeFormatter,
      minWidth: 100,
      maxWidth: 150,
    },
    {
      field: 'createdBy',
      headerName: t('grid.createdBy'),
      headerTooltip: t('grid.createdBy'),
      cellRenderer: 'userNameFromEmailCellRenderer',
      filterValueGetter: createdByFilterValueGetter,
      minWidth: 100,
      maxWidth: 200,
    },
  ];

  return colDefs;
};

export default useColdefManageUser;
